import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { useHistory } from "react-router-dom";
import { RESTExecutor, withDomains } from "../../lib/domain";
import moment from "moment";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const customStyles = `
  /* Responsive styles for mobile dev              >
                {error ? error : "Your organization is being configured. Please wait..."}
              </div>*/
  @media (max-width: 768px) {
    .registration-container {
      padding: 40px 16px !important;
    }

    .registration-card {
      width: 100% !important;
      padding: 24px 20px !important;
    }

    .registration-title {
      font-size: 20px !important;
    }
  }

  /* Desktop styles */
  @media (min-width: 769px) {
    .registration-container {
      padding: 104px 88px !important;
    }

    .registration-card {
      width: 464px !important;
      padding: 32px 48px !important;
    }

    .registration-title {
      font-size: 24px !important;
    }
  }
`;

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
};

const Fourth = ({ formData, extra, navigation, setRegId, domains }) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const [registering, setRegistering] = useState(false);
  const [error, setError] = useState(null);
  const { next } = navigation;
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const is_app_request = query.get("is_app_request");

  const register_company = RESTExecutor.post()
    .config({
      label: "namespace_register",
    })
    .callbacks(
      (success) => {
        console.log("Company registration successful", success);
        const registrationId =
          success.result?.id || success.result?.registration_id;
        if (registrationId) {
          setRegId(registrationId);
        }

        if (is_app_request) {
          setTimeout(() => {
            if (window.flutter_inappwebview) {
              window.flutter_inappwebview.callHandler("userCreated", {
                userId: 123,
              });
            }
          }, 1500);
        }

        next();
      },
      (error) => {
        console.log("Company registration failed", error);
        setRegistering(false);

        if (error?.validation_errors) {
          const validationMessages = Object.entries(error.validation_errors)
            .map(([field, message]) => `${field}: ${message}`)
            .join(", ");
          setError(`Validation errors: ${validationMessages}`);
        } else {
          setError(
            error?.error_message || "Registration failed. Please try again.",
          );
        }
      },
    )
    .connect(domains.register);

  const submitRegistration = () => {
    setRegistering(true);
    setError(null);

    if (!formData.name || !formData.slug) {
      setError("Organization name and workspace name are required.");
      setRegistering(false);
      return;
    }

    const features = extra.namespace_features || {
      track_inventory: false,
      manufacturing_enabled: false,
      pos_enabled: false,
      location_enabled: false,
      warehouse_enabled: false,
      multi_currency_enabled: false,
      pos_retail_enabled: false,
      pos_restaurant_enabled: false,
    };

    const registrationData = {
      name: formData.name,
      display_name: formData.display_name || formData.name,
      slug: formData.slug,
      email: formData.email || null,
      phone_number: formData.phone || null,
      registered_address: formData.address || null,
      website: formData.website || null,
      pan_no: formData.panNumber || null,
      referral_code: formData.promoCode || null,

      logo: formData.logo || null,

      industry: formData.industry || null,

      accounting_start_date:
        extra.accounting_start_date &&
        moment(extra.accounting_start_date).isValid()
          ? moment(extra.accounting_start_date).format("DD-MM-YYYY")
          : "16-07-2025",
      vat_registered: extra.vat_registered || false,

      track_inventory: features.track_inventory,
      manufacturing_enabled: features.manufacturing_enabled,
      pos_enabled: features.pos_enabled,
      location_enabled: features.location_enabled,
      warehouse_enabled: features.warehouse_enabled,
      multi_currency_enabled: features.multi_currency_enabled,
      pos_retail_enabled: features.pos_retail_enabled,
      pos_restaurant_enabled: features.pos_restaurant_enabled,
      cloudflare_token: extra.cloudflare_token || null,
    };

    console.log("Submitting registration data:", registrationData);
    console.log("Form data:", formData);
    console.log("Extra data:", extra);
    register_company.execute(registrationData);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      submitRegistration();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="registration-container"
      style={{
        backgroundColor: "#EEF2F7",
        minHeight: "100vh",
        padding: isMobile ? "40px 16px" : "104px 88px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 48,
      }}
    >
      <style>{customStyles}</style>

      <div
        style={{
          padding: 20.17,
          overflow: "hidden",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: 11.53,
          display: "flex",
        }}
      >
        <div
          style={{
            width: 67.66,
            height: 67.66,
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src="images/logo.svg"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
            alt="Tigg Logo"
          />
        </div>
      </div>

      <div
        style={{
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: 24,
          display: "flex",
        }}
      >
        <div
          className="registration-card"
          style={{
            width: isMobile ? "100%" : 464,
            maxWidth: 550,
            paddingLeft: isMobile ? 20 : 48,
            paddingRight: isMobile ? 20 : 48,
            paddingTop: 32,
            paddingBottom: 32,
            background: "white",
            boxShadow: "0px 28px 62px rgba(37, 78, 207, 0.03)",
            borderRadius: 16,
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 20,
            display: "flex",
          }}
        >
          {error ? (
            <div
              style={{
                color: "var(--Error, #E82E49)",
                fontSize: "24px",
                textAlign: "center",
              }}
            >
              ⚠️
            </div>
          ) : (
            <Spin
              size="large"
              style={{
                fontSize: "24px",
              }}
            />
          )}

          <div
            style={{
              alignSelf: "stretch",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 16,
              display: "inline-flex",
            }}
          >
            <div
              style={{
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: 2,
                display: "inline-flex",
                width: "100%",
              }}
            >
              <div
                className="registration-title"
                style={{
                  alignSelf: "stretch",
                  textAlign: "center",
                  color: "#343C46",
                  fontSize: isMobile ? 20 : 24,
                  fontFamily: "Inter",
                  fontWeight: "700",
                  wordWrap: "break-word",
                }}
              >
                {error
                  ? "Registration Error"
                  : "Getting Your Organization Ready.."}
              </div>
              <div
                style={{
                  alignSelf: "stretch",
                  textAlign: "center",
                  color: "#969798",
                  fontSize: 14,
                  fontFamily: "Inter",
                  fontWeight: "400",
                  wordWrap: "break-word",
                  lineHeight: "20px",
                }}
              >
                {registering
                  ? "Your organization is being configured. Please wait..."
                  : error
                    ? error
                    : "Your company registration has been submitted successfully!"}
              </div>
            </div>
          </div>

          {error && (
            <div style={{ marginTop: 16 }}>
              <button
                onClick={submitRegistration}
                style={{
                  padding: "12px 24px",
                  background: "var(--Main-blue, #143E9F)",
                  color: "white",
                  border: "none",
                  borderRadius: 6,
                  fontSize: 14,
                  fontFamily: "Inter",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                Try Again
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withDomains(Fourth, "register");
